module.exports = __webpack_public_path__ + "static/img/p2.7126f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure/p2.png
// module id = 6R2c
// module chunks = 1